<template>
  <div class="animated fadeIn">
    <b-card no-body class="mt-1 mb-1">
      <b-card-header>
        <span v-if="header" class="text-muted text-uppercase">
          <i v-if="icon" :class="`fal fa-${icon} mr-2`" />
          {{ header }}
        </span>
      </b-card-header>

      <div v-if="formatted_rows.length" class="py-3 px-4">
        <b-row class="pr-3">
          <b-col
            v-for="(row, rowIndex) in formatted_rows"
            :key="rowIndex"
            sm="12"
            md="6"
            class="pr-0"
          >
            <b-row class="pr-3">
              <b-col v-if="row.label" class="pr-0">
                <label class="font-weight-bold">
                  {{ row.label }}
                </label>
              </b-col>
              <b-col class="pr-0">
                <span>{{ row.value }}</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import CustomerLocationModel from '@/models/crm/CustomerLocationModel'

export default {
  name: 'CustomerLocationCard',
  props: {
    location: {
      type: Object,
      default: () => new CustomerLocationModel()
    }
  },
  computed: {
    header () {
      const { type } = this.location
      return `${type ? type.toUpperCase() : 'Billing'} Address`
    },

    icon () {
      return this.location.icon()
    },

    rows () {
      const { city, country, postal_code, region, street_address } =
        this.location
      const location_city = [city, region, country].filter((item) => item)

      return [
        {
          label: null,
          value: street_address || 'TBD'
        },
        {
          label: null,
          value: location_city.length ? location_city.join(', ') : 'TBD'
        },
        {
          label: null,
          value: postal_code || 'TBD'
        }
      ]
    },

    formatted_rows () {
      const rows = []

      for (let i = 0; i < this.rows.length; i++) {
        if (this.rows[i].value) {
          const row = this.rows[i]

          !row.slot &&
            (row.slot = row.label ? row.label.replace(/\s+/g, '') : `row-${i}`)
          rows.push(row)
        }
      }

      return rows
    }
  }
}
</script>
